import React, { memo, useEffect, useCallback } from 'react';
import { getGameList } from '../../../actions/order';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../components/Loading/Loading';
import InfiniteScroll from 'react-infinite-scroller';
import useLoginStatus from '../../../utils/hooks/useLoginStatus';
import styles from './GameOrder.module.less';
import { createSelector } from 'reselect';
import Default from '../../../static/order_lack.svg';
import GameCard from '../Card/GameCard/GameCard';
import { logging, logPostInfo } from '../../../actions/log';
import { useHistory, useLocation } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import DefaultLogin from '../DefaultLogin/DefaultLogin';

const gameListSelect = createSelector(
  state => state.order,
  order => order,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ node }) => {
  const loginStatus = useLoginStatus();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const logInfoData = useSelector(selectLogInfo);
  let nowPage = 1;
  const { gameLoading, gameTotal, gameList } = useSelector(gameListSelect);

  useEffect(() => {
    if (loginStatus) {
      dispatch(getGameList({ page: 1, size: 24, refresh: true }));
    }
    if (loginStatus && gameList && gameList.length !== 0) {
      dispatch(
        logging({
          category: 'P',
          action: 'Game_Orders',
          label: '',
          param2: {
            source: 'Game_Orders',
            source_p: logInfoData.source,
            source_pp: logInfoData.source_p,
          },
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (location.search.indexOf('updatePage') > -1) {
      let id = location.search.substring(location.search.indexOf('=') + 1);
      if (id === '1') {
        dispatch(getGameList({ page: 1, size: 24, refresh: true }));
      }
    }
  }, [location]);
  const jumpOther = () => {
    history.push(`${CONTEXT}/recommend`);
  };

  const loadMore = useCallback(() => {
    nowPage++;
    dispatch(getGameList({ page: nowPage, size: 24, refresh: false }));
  }, [nowPage]);
  return (
    <div className={styles.game_order}>
      {!loginStatus && <DefaultLogin />}
      {loginStatus && (
        <>
          {gameLoading && (
            <div className={styles.default}>
              <Loading />
            </div>
          )}
          {!gameLoading && (
            <>
              {gameList.length === 0 && (
                <div className={styles.default}>
                  <div>
                    <img src={Default} />
                  </div>
                  <div className={styles.describe}>
                    <span>您暂时还没有订单</span>
                    <span className={styles.jump_other} onClick={jumpOther}>
                      去逛逛
                    </span>
                  </div>
                </div>
              )}
              {gameList.length > 0 && (
                <InfiniteScroll
                  page={1}
                  loadMore={loadMore}
                  hasMore={(gameList && gameList.length) < gameTotal}
                  loader={
                    <div className="loader" key={0}>
                      ----------加载中----------
                    </div>
                  }
                  initialLoad={false}
                  useWindow={false}
                  getScrollParent={() => node}
                >
                  {gameList.map((el, index) => (
                    <GameCard info={el} key={index} />
                  ))}
                </InfiniteScroll>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
});
